import RouteContainer from 'containers/RouteContainer';
import Summary from './components/Summary';

export const path = '/';

export default RouteContainer(path, Summary, { exact: true });
